import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';
import PageBanner from '../Components/PageBanner';

const clients = [
    {
        name: 'ATS',
        place: 'Noida & Greater Noida',
        pill: 'Residential & commercial developer',
        image: '/projects/3/1.jpeg',
        text: 'SS 304 and ACP cladding at ATS Destinaire, powder-coated and anodized aluminium at ATS Picture Square, and SS 304 sheet cladding at ATS Dolce.',
    },
    {
        name: 'Saya',
        place: 'Greater Noida & Ghaziabad',
        pill: 'Residential developer',
        image: '/projects/9/1.jpeg',
        text: 'facade work at Saya South X, and ACP front elevation with aluminium glazing and interior work at the Saya marketing office.',
    },
    {
        name: 'Supertech',
        place: 'Sector 74, Noida',
        pill: 'Real estate developer',
        image: '/projects/8/2.jpg',
        text: '4mm ACP sheet cladding at Supertech ORB, Sector 74, Noida.',
    },
    {
        name: 'Gaur Sons',
        place: 'Ghaziabad',
        pill: 'Township developer',
        image: '/projects/12/1.jpg',
        text: 'Curtain wall elevation with aluminium framing and glass at Passport Studios.',
    },
    {
        name: 'Spectrum Mall',
        place: 'Sector 75, Noida',
        pill: 'Commercial mall developer',
        image: '/projects/10/1.jpeg',
        text: 'UPVC and aluminium doors and windows, SS and MS railing, and office interior works at Spectrum Mall, Phase 1.',
    },
    {
        name: 'T&T',
        place: 'Ghaziabad',
        pill: 'Housing & infrastructure',
        image: '/projects/6/2.jpeg',
        text: 'Fabrication and installation of MS staircase railing.',
    },
    {
        name: 'Paras Estate',
        place: 'Meerut',
        pill: 'Commercial & residential',
        image: '/projects/13/1.jpg',
        text: 'Elevation and facade works with Georgian bar detailing and aluminium glazing.',
    },
    {
        name: 'Navrang Square',
        place: 'Ghaziabad',
        pill: 'Retail & commercial hub',
        image: '/projects/2/2.jpeg',
        text: 'facade glazing, glass doors and windows, spider glazing, skylight, ACP cladding and civil works.',
    },
    {
        name: 'Amba Deep',
        place: 'Connaught Place, Delhi',
        pill: 'Commercial tower',
        image: '/projects/4/1.jpeg',
        text: 'Aluminium fixed windows with 6mm HD blue toughened glass at Amba Deep, Connaught Place.',
    },
    {
        name: 'CSN',
        place: 'Jamshedpur',
        pill: 'Industrial facility',
        image: '/projects/1/1.jpeg',
        text: 'Glazing with powder-coated aluminium frames in Champagne colour and an approved shade.',
    },
    {
        name: 'Central Market',
        place: 'Sector 120, Noida',
        pill: 'Retail & commercial',
        image: '/projects/11/1.jpeg',
        text: 'Glass railing, facade glazing, glass doors and glass windows.',
    },
];

const Clients = () => {
    useReveal();

    return (
        <div>
            <PageBanner
                title="Clients & Enterprise Partners"
                text="Developers and commercial projects we have fabricated and installed across Delhi NCR, with facade work also delivered in Jamshedpur."
                image="/projects/4/2.jpeg"
            />
            <section className="page-section">
                <div className="container">
                    <div className="client-grid">
                        {clients.map((client) => (
                            <article className="client-card reveal" key={client.name}>
                                <div className="client-card-top">
                                    <img
                                        src={`${process.env.PUBLIC_URL}${client.image}`}
                                        alt=""
                                        className="client-thumb"
                                    />
                                    <span className="client-pill">{client.pill}</span>
                                </div>
                                <h3>{client.name}</h3>
                                <p className="client-place">{client.place}</p>
                                <p>{client.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
            <section className="home-cta">
                <div className="container reveal">
                    <h2>Ready to discuss your facade?</h2>
                    <p>Glazing, cladding, aluminium and UPVC work for the next project.</p>
                    <Link className="hero-btn is-solid" to="/contact">Contact us</Link>
                </div>
            </section>
        </div>
    );
};

export default Clients;
